import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdateDemoShiftOnTimeAttendanceOptOutParams {
  workplaceId: string;
  enabled: boolean;
}

export function useUpdateDemoShiftOnTimeAttendanceOptOut(
  options: UseMutationOptions<
    WorkplaceProfileResponse,
    unknown,
    UpdateDemoShiftOnTimeAttendanceOptOutParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, enabled }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: {
              demoShift: { onTimeAttendanceOptOut: enabled },
            },
          },
        },
        requestSchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
